import { useSearchPersist } from '@/components/DataGrid/hooks/useSearchPersist';
import { MasterAddNameDetails } from '@/layouts/TabLayout/MasterNames/components/MasterAddNameDetails';

import MasterIndexPersonBase from './MasterIndexPersonBase';

const MasterIndexPersonForm = () => {
  const { navigateWithSearch } = useSearchPersist();

  return (
    <MasterIndexPersonBase>
      <MasterAddNameDetails
        onGoBack={() => navigateWithSearch('/master-index/persons')}
        hideHeader={true}
        isMasterIndex={true}
      />
    </MasterIndexPersonBase>
  );
};

export default MasterIndexPersonForm;
